import styled from 'styled-components'
import {
  SharedNotificationAvatar,
  SharedNotificationContent,
  SharedNotificationDate,
  SharedNotificationLeft,
  SharedNotificationRight,
  SharedNotificationRow,
  SharedNotificationTitle,
} from '../../components/NotificationShared/NotificationItemStyled'

export const PopupListWrapper = styled.div`
  max-height: min(660px, calc(88vh - 120px));
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
`

export const PopupItemRow = styled(SharedNotificationRow).attrs({
  $variant: 'popup',
})`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 32px;
`

export const PopupItemLeft = styled(SharedNotificationLeft).attrs({
  $variant: 'popup',
})``

export const PopupAvatar = styled(SharedNotificationAvatar).attrs({
  $variant: 'popup',
})``

export const PopupContentGroup = styled(SharedNotificationContent).attrs({
  $variant: 'popup',
})``

export const PopupItemTitle = styled(SharedNotificationTitle).attrs({
  $variant: 'popup',
})``

export const PopupItemDate = styled(SharedNotificationDate).attrs({
  $variant: 'popup',
})`
  font-size: 10px;
  line-height: 14px;
  white-space: nowrap;
`

export const PopupItemRight = styled(SharedNotificationRight).attrs({
  $variant: 'popup',
})`
  margin-left: 0;
`

// Backwards compatibility for external imports
export const ContentLoading = styled.div`
  margin: 20px 0;
  padding: 30px 50px;
  text-align: center;
  border-radius: 4px;
`
